import { useMemo } from 'react';

import { WizardStepConfig } from '@bambi/component-library/src/components/Wizard/base/types';
import { ProgressBarWizard } from '@bambi/component-library/src/components/Wizard/ProgressBarWizard';

import { useAppSelector } from 'src/app/store/hooks';
import { ModalProps } from 'src/common/primitives/Modal';

import { CondensedPDFStep1 } from './steps/CondensedPDFStep1';
import { CondensedPDFStep2 } from './steps/CondensedPDFStep2';

interface DownloadInvoicesCondensedPDFProps {
  onClose: ModalProps['onClose'];
}

export function DownloadInvoicesCondensedPDF({
  onClose,
}: DownloadInvoicesCondensedPDFProps) {
  const skipExportGatherDataStep = useAppSelector(
    (state) => state.invoice.skipExportGatherDataStep
  );

  const steps = useMemo(() => {
    const allSteps: WizardStepConfig[] = [
      {
        title: 'Select data',
        render: ({ next, prev }) => (
          <CondensedPDFStep1 next={next} prev={prev} onClose={onClose} />
        ),
      },
      {
        title: 'Generation options',
        render: ({ next, prev }) => (
          <CondensedPDFStep2 next={next} prev={prev} onClose={onClose} />
        ),
      },
    ];

    if (skipExportGatherDataStep) {
      allSteps.shift();
    }

    return allSteps;
  }, [onClose, skipExportGatherDataStep]);

  return (
    <ProgressBarWizard testId="download-invoices-condensed-pdf" steps={steps} />
  );
}
